import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, popupSales } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const cycle = (i: number) => {
      timeout = setTimeout(() => {
        setIndex(i % popupSales.length);
        setVisible(true);
        timeout = setTimeout(() => {
          setVisible(false);
          cycle(i + 1);
        }, 5200);
      }, 3200);
    };
    cycle(0);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const sale = popupSales[index];
  return <AnimatePresence data-id="element-129" data-mp="1dpovuhvciwkj">
      {visible && !dismissed ? <motion.aside initial={{
      opacity: 0,
      y: 14,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 14,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2 left-2 z-50 w-[15rem] overflow-hidden rounded-lg border-2 border-gold bg-white shadow-[0_8px_22px_-6px_rgba(11,37,69,0.55)] sm:w-[17rem]" aria-live="polite" data-id="element-130" data-mp="18q2i87blveb7">
          <div className="flex items-center gap-1.5 bg-teal px-2 py-1" data-id="element-131" data-mp="2ehtu1pdaxc1h">
            <span className="text-[0.85rem] leading-none" aria-hidden="true" data-id="element-132" data-mp="2ih2okwg61dy3">
              🩻
            </span>
            <p className="text-[0.56rem] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-133" data-mp="2nfma4vquknpx">
              New purchase verified
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="ml-auto text-white/80 transition-colors duration-150 ease-out hover:text-white" data-id="element-134" data-mp="2xf3b4zv5mdfk">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-135" data-mp="133g84q23z6o3" />
            </button>
          </div>
          <a href={PURCHASE_ANCHOR} className="block px-2 py-1.5" data-id="element-136" data-mp="v0wcdsserz0s">
            <p className="text-[0.72rem] font-bold leading-tight text-navy" data-id="element-137" data-mp="q2mj5nq8v8ht">
              {sale.name} just bought ULTRASOUND VISUAL ATLAS™
            </p>
            <p className="mt-0.5 text-[0.62rem] font-semibold text-charcoal/80" data-id="element-138" data-mp="zzqxj1dulzo2">
              {sale.city}, {sale.country} • a few minutes ago
            </p>
          </a>
        </motion.aside> : null}
    </AnimatePresence>;
}